import { ApiPromise } from '@/types';
import { AssessmentPayload, AssessmentOptions } from '@/types/AssessmentManagement';
import { HTTP } from '@/utils';

export interface AssessmentFilterInterface {
  search?: string;
  page?: string | number;
  per_page?: number;
  order?: string;
  order_by?: string;
  publisher?: number;
}

export default class AssessmentService {
  static resource = 'tenant/assessments';

  static getAssessments(filters?: AssessmentFilterInterface): ApiPromise {
    let queryString = '';

    if (filters) {
      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
          params.append(key, value.toString());
        }
      });
      queryString = `?${params.toString()}`;
    }

    return HTTP.get(`${this.resource}${queryString}`);
  }

  static getAssessment(id: number): ApiPromise {
    return HTTP.get(`${this.resource}/${id}`);
  }

  static createAssessment(payload: AssessmentPayload): ApiPromise {
    return HTTP.post(this.resource, payload);
  }

  static updateAssessment(id: number, payload: AssessmentPayload): ApiPromise {
    return HTTP.post(`${this.resource}/${id}`, payload);
  }

  static deleteAssessment(id: number): ApiPromise {
    return HTTP.delete(`${this.resource}/${id}`);
  }

  static getOptions(): ApiPromise<AssessmentOptions> {
    return HTTP.get(`${this.resource}/options`);
  }
}
